const MediaQueries = (breakPoint: number) => {
    return `@media (min-width: ${breakPoint}px)`;
};

export default MediaQueries;
